import OTP from "global/otp";
import { OTPTypes } from "global/otp/types";
import OrderFactor from "pages/OrderManagement/views/Order/Elements/order-factor";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setNewConsignments, setOrder } from "redux/OrderData/OrderData";
import { getUrls } from "services/api.enums";
import SimpleButton from "../../../../global/SimpleButton/SimpleButton";
import { addEditDataAPI, getAPI } from "../../../../services/CRUDServices";
import PaymentModal from "./payment/PaymentModal";
import { usePayment } from "./payment/utils/usePayment";
import NationlCodeValidation from "./NationlCodeValidation";

interface InvoiceProps {
  data: {
    invoicePrice: {
      invoicePrice?: number;
      pickupPrice?: number;
      postBackPrice?: number;
      taxPrice?: number;
      total: number;
      packagePrice?: number;
      codPrice?: number;
    };
    extraCost?: number;
    discount?: number;
    discountAmount?: number;
    totalDiscount?: number;
    inVoiceNumber: number;
    inVoiceId: number;
    consignmentIntraCity: number;
    consignmentIntercity: number;
    sumOfBasePrice: number;
    taxPrice: number;
    pickupPrice: number;
    invoiceCode: string;
    consignmentExternalCity: number;
    supplementaryService: [{ price: number; serviceid: number }];
  };

  paymentMode?: any;
  discountType?: number;
  isIdentityOrder?: boolean;
}

const OrderFacture = ({
  data,
  paymentMode,
  discountType,
  isIdentityOrder,
}: InvoiceProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { orderData, consignments } = useSelector((state: any) => state.Order);
  const { orderManagementData } = useSelector((state: any) => state.orderData);
  const { otpCode } = useSelector((state: any) => state.OTP);
  const [modals, setModals] = useState<OTPTypes>({
    verificationModal: false,
    OTPModal: false,
    nationalCodeValidation: false,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleClick } = usePayment();
  const handleSubmitOrderFacture = () => {
    if (!paymentMode) {
      if (
        consignments.every((item: any) => item.price) &&
        consignments.every(
          (item: any) => item?.receiverCustomerId || item?.receiverProspectId
        )
      ) {
        dispatch(
          setOrder({
            inVoiceNumber: data?.invoiceCode,
            inVoiceId: data?.inVoiceId,
            consignmentIntraCity: data?.consignmentIntraCity,
            consignmentIntercity: data?.consignmentIntercity,
            sumOfBasePrice: data?.invoicePrice?.total,
            // sumOfBasePrice: data?.sumOfBasePrice,
            taxPrice: data.invoicePrice?.taxPrice,
            // taxPrice: taxPrice,
            pickupPrice: data?.invoicePrice?.pickupPrice,
            // pickupPrice: data?.pickupPrice,
          })
        );
        setLoading(true);
        getAPI(getUrls.findAllInvoiceDetailsInOrder + orderData?.orderId)
          .then((res: any) => {
            const invoiceData = res.data.payload;
            getAPI(getUrls.invoiceAssign + orderData?.orderId)
              .then(() => {
                const newConsignemnts = consignments.map((item: any) => ({
                  ...item,
                  payBy: invoiceData.find(
                    (invoice: any) =>
                      invoice.consignment.id === item.consignmentId
                  )?.paymentBy?.id,
                  bill: invoiceData.find(
                    (invoice: any) =>
                      invoice.consignment.id === item.consignmentId
                  )?.bill,
                  invoiceDetailsId: invoiceData.find(
                    (invoice: any) =>
                      invoice.consignment.id === item.consignmentId
                  ).id,
                }));

                dispatch(setNewConsignments(newConsignemnts));
                if (orderManagementData?.easyOrder) {
                  let invoiceData = newConsignemnts.map((item: any) => ({
                    paymentBy: { id: item.paymentBy?.id },

                    invoiceDetailsId: item?.invoiceDetailsId,
                    orderId: orderManagementData?.orderId || orderData?.orderId,
                    customerId:
                      orderManagementData?.senderCustomerId ||
                      orderData?.senderCustomerId,
                    isAdminPanel: true,
                  }));

                  addEditDataAPI(
                    // data?.discountAmount
                    // ?
                    `/consignment-api/invoice/invoiceDetailsPayment?discount=${
                      data?.discount || 0
                    }&serviceId=81&paymentBy=${discountType || 0}`,
                    // : "consignment-api/invoice/invoiceDetailsPayment",
                    "post",
                    invoiceData
                  )
                    .then((res) => {
                      dispatch(setOrder(res.data.payload));
                      setLoading(false);
                      if (
                        consignments.some(
                          (item) =>
                            item.paymentBy?.id === 0 || item.paymentBy === null
                        )
                      ) {
                        setIsOpen(true);
                      } else {
                        handleClick(false, {
                          ...orderData,
                          ...res.data.payload,
                        });
                      }
                      // if (
                      //   !consignments.every((item) =>
                      //     item.supplementary.some((sub) => sub.serviceType === 1)
                      //   )
                      // ) {
                      //   setIsOpen(true);
                      //   // handleClick(true, res.data.payload);
                      // } else {
                      //   handleClick(false, { ...orderData, ...res.data.payload });
                      // }
                    })
                    .catch(() => setLoading(false));

                  return;
                }
                navigate("/consignments-payment");
                setLoading(false);
              })
              .catch(() => setLoading(false));
          })
          .catch(() => setLoading(false));
      } else {
        toast.error("ابتدا اطلاعات مرسوله را کامل کنید");
      }
    }
  };

  // const extraPrice = data?.supplementaryService.find(
  //   (servcie: any) => servcie?.serviceid === 161
  // )?.price

  async function sendOTP(mobile) {
    await addEditDataAPI(`/consignment-api/order/sendOtpFromCustomer`, "post", {
      id: orderManagementData.orderId,
      text: mobile,
    });

    setModals((prev: OTPTypes) => ({
      ...prev,
      OTPModal: true,
      verificationModal: false,
    }));
  }

  async function checkOTP() {
    try {
      await addEditDataAPI(
        `/consignment-api/order/checkOtpFromCustomer`,
        "post",
        {
          id: orderManagementData.orderId,
          text: +otpCode,
        }
      );

      setModals((prev: OTPTypes) => ({
        ...prev,
        OTPModal: false,
        verificationModal: false,
      }));
      handleSubmitOrderFacture();
    } catch {}
  }

  return (
    <div className="rounded-2xl w-80 bg-white border  shadow-sm p-4">
      <p className="text-center text-2xl mb-3 text-dark">صورت حساب</p>

      {isIdentityOrder ? (
        <OrderFactureElements
          title="تعداد متقاضی"
          price={consignments?.length || 0}
          notToman
        />
      ) : (
        <>
          <OrderFactureElements
            title="مرسوله درون شهری"
            price={data?.consignmentIntraCity || 0}
            notToman
          />
          <OrderFactureElements
            title="مرسوله بین شهری"
            price={data?.consignmentExternalCity || 0}
            notToman
          />
        </>
      )}

      <OrderFactor
        invoicePrice={{
          ...data?.invoicePrice,
          // extraPrice:data?.extraCost,
          discountAmount: data?.discountAmount,
        }}
        isIdentityOrder={isIdentityOrder}
      />
      <SimpleButton
        handelClick={() => {
          isIdentityOrder
            ? handleSubmitOrderFacture()
            : setModals({ ...modals, nationalCodeValidation: true });
        }}
        // handelClick={() => setModals({ ...modals, verificationModal: true })}
        disabled={orderData?.inVoiceStatusId === 2}
        loading={loading}
        type={paymentMode ? "submit" : "button"}
        className={
          orderData?.inVoiceStatusId === 2
            ? "opacity-100 border border-tomato bg-white text-tomato w-full text-base font-semibold"
            : "w-full full-tomato-btn"
        }
        text={
          orderData?.inVoiceStatusId === 2 ? "پرداخت شده" : "تایید و پرداخت"
        }
      />
      <OTP
        mobile={orderManagementData.mobile}
        modals={modals}
        setModals={setModals}
        showBtn={false}
        handleSendOTP={sendOTP}
        handleCheckOTP={checkOTP}
        isCustom={true}
      />
      <PaymentModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isIdentityOrder={isIdentityOrder}
      />
      <NationlCodeValidation
        isOpen={modals.nationalCodeValidation}
        setIsOpen={setModals}
      />
    </div>
  );
};

export default OrderFacture;

export const OrderFactureElements = ({ title, price, notToman }: any) => (
  <div className="flex-between-center my-5">
    <p>{title}</p>
    <p>
      {price.toLocaleString()} {notToman ? "" : "ریال"}
    </p>
  </div>
);
